import axiosHttp from "services/axiosHttp";
import { MEAL_BASE_URL } from "configs/AppConfig";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchMealSupplierList = createAsyncThunk("fetchMealSupplierList", async ({ filters, page, limit }, { rejectWithValue }) => {

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
		is_active: filters?.is_active ?? "",
		location_id: filters?.location_id ?? ""
	});

	try {
		const response = await axiosHttp.get(`${MEAL_BASE_URL}/suppliers?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});

const MealSupplierListSlice = createSlice({
	name: "MealSupplierListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchMealSupplierList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMealSupplierList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});

		builder.addCase(fetchMealSupplierList.rejected, (state, action) => {
			state.isLoading = false;

			if (action.error.message) {
				state.error = action.error.message;
			} else {
				state.error = "Unknown error occurred";
			}
		});
	},
});

export default MealSupplierListSlice.reducer;
